'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

import 'angular-validation-match';

import 'angucomplete-alt';

import {
    routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import admin from './admin';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import main from './main/main.component';
import feedback from './feedback/feedback.component';
import articles from './articles/articles.component';
import article from './article/article.component';
import articleVideo from './articleVideo/articleVideo.component';
import recipes from './recipes/recipes.component';
import recipe from './recipe/recipe.component';
import initiatives from './initiatives/initiatives.component';
import initiative from './initiative/initiative.component';
import initiativeVideo from './initiativeVideo/initiativeVideo.component';
// import docs from './docs/docs.component';
import constants from './app.constants';
import util from '../components/util/util.module';


// Services
import searchService from '../components/services/searchService/searchService.service';

import './app.scss';

angular.module('connectwellApp', [ngCookies, ngResource, ngSanitize, uiRouter, uiBootstrap, 'angucomplete-alt', _Auth, account,
        admin, 'validation.match', navbar, footer, main, feedback, articles, article, articleVideo, recipes, recipe, initiatives, initiative, initiativeVideo, constants, util, searchService
    ])
    .config(routeConfig)
    .run(function($rootScope, $location, Auth) {
        'ngInject';
        // Redirect to login if route requires auth and you're not logged in

        $rootScope.$on('$stateChangeStart', function(event, next) {
            Auth.isLoggedIn(function(loggedIn) {
                if (next.authenticate && !loggedIn) {
                    $location.path('/login');
                }
            });
        });

        
        $rootScope.$watch('canonical', function(newVal){
            if(newVal != '') {
                var link = angular.element('<link>');
                link.attr('rel', 'canonical');
                link.attr('href', newVal);

                angular.element('head').append(link);
            }
        })
    });

angular.element(document)
    .ready(() => {
        angular.bootstrap(document, ['connectwellApp'], {
            strictDi: true
        });
    });


// WEBPACK FOOTER //
// ./client/app/app.js